// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { callApi } from "../generic/callApi";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await callApi({ method: "get", url: "/auth/profile" });
        setUser(res?.user || null);
      } catch (error) {
        setUser(null);
        console.warn("🔴 Not authenticated:", error?.response?.status);
      } finally {
        setLoading(false);
        setCheckingAuth(false);
      }
    };

    fetchUser();
  }, []);

  const login = async (credentials, check) => {
    try {
      const res = await callApi({
        method: "post",
        url: "/auth/user-login",
        body: credentials,
      });

      const userData = res?.data?.user;
      setUser(userData);

     
    {    check && navigate("/post-properties/basic-info");}
      

      return { success: true };
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Login failed";
      console.error("Login error:", errorMessage);
      return { success: false, message: errorMessage };
    }
  };

  const createAccount = async (credentials) => {
    try {
      const res = await callApi({
        method: "post",
        url: "/auth/user-register",
        body: credentials,
      });
      setUser(res?.data?.user || null);
      navigate("/");
      return { success: true };
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Registration failed";
      console.error("Registration error:", errorMessage);
      return { success: false, message: errorMessage };
    }
  };

  const logout = async () => {
    try {
      await callApi({ method: "post", url: "/auth/logout" });
      setUser(null);
      setTimeout(() => navigate("/", { replace: true }), 100);
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout, createAccount }}>
      {!checkingAuth && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
